import PropTypes from 'prop-types';

/* PropTypes */

export const SelectBoxPropTypes = {
  action: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.node,
  ]),
  components: PropTypes.shape({}),
  disabled: PropTypes.bool,
  error: PropTypes.string,
  flash: PropTypes.bool,
  invisible: PropTypes.bool,
  isClearable: PropTypes.bool,
  isCreatable: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  pageStyle: PropTypes.bool,
  required: PropTypes.bool,
};

/* Default props */

export const SelectBoxDefaultProps = {
  action: null,
  components: {},
  disabled: false,
  error: null,
  isClearable: false,
  isCreatable: false,
  isLoading: false,
  label: null,
  required: null,
};
